/**
 * Feb 28, 2026 · Export Order Reconciliation
 *
 * Thin wrapper over `SalesOrderReconciliation` that locks the source to
 * ESO so the Exports module gets a dedicated fulfilment view without
 * duplicating the whole page shell.
 */
import SalesOrderReconciliation from "@/pages/SalesOrderReconciliation";

export default function ExportOrderReconciliation() {
  return (
    <SalesOrderReconciliation
      defaultSource="ESO"
      lockSource
      title="Export Order Reconciliation"
      subtitle="Order Qty · Dispatched · Excess Produced · FG Stock · Balance Pending — per ESO line."
      testIdPrefix="eso-reconciliation"
    />
  );
}
